import { Injectable } from "@angular/core";
import { ClientService } from "../services/client.service";
import { ArrayClientRepository } from "./abstract/array.client.repository";
import { Printable } from "../types/Printable/Printable";

@Injectable({
  providedIn: "root",
})
export class PrintableRepository extends ArrayClientRepository<Printable> {
  constructor(clientService: ClientService) {
    super(
      clientService,
      "schemas.schCFG_IREF_Printable.records",
      "printableID",
    );
  }

  public getPrintablesByInspectionTypeID(inspectionTypeID: string) {
    return super.getFilteredByValue("inspectionTypeID", inspectionTypeID);
  }
}
